import Accordion from '@/components/Accordion'
import JsonLd from '@/components/JsonLd'
import { buildFaqPage } from '@/lib/schema'

const Questions = ({ data, swiperData = {} }) => {
  if (!data || !data.length) {
    return null
  }

  return (
    <>
      <JsonLd data={buildFaqPage(data)} />
      {data.map((question) => {
        const { id, question: title, answer } = question
        return (
          <Accordion key={id} title={title} swiperData={swiperData}>
            {answer}
          </Accordion>
        )
      })}
    </>
  )
}

export default Questions